import { type ReactElement } from 'react'
import { TButton } from 'app/components/buttons'
import { useTranslation } from '@front/model'
import { type FocusRow } from '../types'
import { useTeamHierarchyContext } from '../TeamHierarchyContext'
import classes from './hierarchyViewport.module.css'

export const RowOverflowNode = ({ row }: { row: FocusRow }): ReactElement => {
  const { t } = useTranslation()
  const { toggleRowExpanded } = useTeamHierarchyContext()

  const label = row.isExpanded ? t('Show fewer') : t('+{{count}} more', { count: row.overflowCount })

  return (
    <TButton
      noTranslation
      data-no-pan='true'
      className={classes.overflowNode}
      icon={row.isExpanded ? 'unfold_less' : 'unfold_more'}
      variant='secondary'
      onClick={() => toggleRowExpanded(row.rowId)}
    >
      {label}
    </TButton>
  )
}
